import { render } from "./WCFooter.vue?vue&type=template&id=60dd4404&scoped=true"
import script from "./WCFooter.vue?vue&type=script&lang=js"
export * from "./WCFooter.vue?vue&type=script&lang=js"

import "./WCFooter.vue?vue&type=style&index=0&id=60dd4404&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60dd4404"]])

export default __exports__